import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_STARTER_EXPERIENCE_DASHBOARD_AI_POST_UPDATE = defineFcm('starter_experience_dashboard_ai_post_update')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				experimentName: { type: 'string' },
				enabled: { type: 'boolean' },
			},
		}),
	)
	.withDefault({
		experimentName: 'starter_experience_ai_post_update',
		enabled: false,
	})
	.toConfig({
		owner: 'squad-axolotl',
		scope: 'corgi-front-end',
		context: 'Starter Dashboard',
		description: 'Controls the visibility of the AI post an update feature.',
		template: {
			experimentName: 'starter_experience_ai_post_update',
			enabled: false,
		},
	});
